import { render, staticRenderFns } from "./newRequestModal.vue?vue&type=template&id=f2d7217a&scoped=true&"
import script from "./newRequestModal.vue?vue&type=script&lang=js&"
export * from "./newRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./newRequestModal.vue?vue&type=style&index=0&id=f2d7217a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d7217a",
  null
  
)

export default component.exports